import Graph from '../Component/Graph';

const SideCard=(props)=>{
    return (
        
        <div className="border">
          <div>
         <div className="d-flex justify-content-between ">
        <p className="fs-3 ps-2 text-light">{props.head} {props.head1} {props.head2}</p>
        <div className="d-flex"> 
        
            <p className="text-light">{props.icon} {props.icon1} {props.icon2}</p>
            <a href="#text" className="text-decoration-none text-light">{props.Data} {props.Data1} {props.Data2}</a>
        </div>
        </div> 
       <p className="text-light ps-2">{props.subhead} {props.subhead1} {props.subhead2}</p>
       <Graph/>

       
       </div>
       </div>
      
    )
}
export default SideCard;
